import React from "react";
import { DateTimeFormat } from "../../helpers/utils";
import TableBase from "./Base";

const SurveysTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Email",
			dataIndex: "email",
			width: 100,
			ellipsis: true,
		},
		{
			title: "Topic",
			dataIndex: "survey_category",
			width: 150,
			ellipsis: true,
			render(survey_category) {
				return (
					<span>
						{survey_category &&
							survey_category.topics &&
							survey_category.topics.length !== 0 &&
							survey_category.topics.map((topic) => topic.name).join(", ")}
					</span>
				);
			},
		},
		{
			title: "Survey Category",
			dataIndex: "survey_category",
			width: 150,
			ellipsis: true,
			render(survey_category) {
				return <span>{survey_category.name}</span>;
			},
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{DateTimeFormat(record)}</span>;
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 80,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SurveysTable;
